export default __webpack_public_path__ + "static/media/dash.b3bd53d1.svg";